<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <Settings
        v-bind:region="'left'"
        v-bind:title="resource('TemplateRowSettings_Settings_Title')"
        v-bind:tooltip="tooltip"
        class="row-settings"
    >
        <template v-slot:body> 

            <settings-color-picker
                v-bind:label="resource('TemplateRowSettings_Settings_Color_Label')"
                v-bind:value="color"
                @input="$emit('change-color', $event)"
            />

        </template>

    </Settings>
</template>

<script>
    import {rowSettingsTooltip} from "../../tooltips";
    import resourceMixin from "../../../../Util/Mixins/resources";
    import SettingsColorPicker from "./SettingsColorPicker.vue";
    import Settings from './Settings.vue';

    export default {
        name: "row-settings",
        mixins: [resourceMixin],
        components: {
            SettingsColorPicker,
            Settings
        },
        data: () => ({ tooltip: rowSettingsTooltip }),
        props: {
            color: {
                type: String,
                required: true
            },
            parentColor: {
                type: String
            }
        }
    };
</script>
